export const CHANGE_COMPANIES_VERSION = 'CHANGE_COMPANIES_VERSION';
export const CHANGE_COMPANY_ADDRESSES_VERSION = 'CHANGE_COMPANY_ADDRESSES_VERSION';
